export const LOCALES ={
    ENGLISH: "en-US",
    SPANISH: "es-ES",
    FRENCH: "fr-FR",
};